import React, { useState, useEffect } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Modal from "../componentes/Modal";
import UsuarioFormEmpresa from "../componentes/UsuarioFormEmpresa";
import Notify from '../componentes/Notify';
import { BotonLetras, BotonEditar, BotonDelete, BotonCheck, BotonUsuarioCajas } from '../componentes/Plantillas/Botones';
import { simpleReactTableColumn } from '../helpers/funcionesGlobales';
import UsuarioCajasEmpresa from '../componentes/UsuarioCajasEmpresa';

const UsuariosEmpresa = () => {
    const [usuarios, setUsuarios] = useState(null);
    const [usuario, setUsuario] = useState(null);
    const [cajas, setCajas] = useState(false);

    const fetchUsuarios = async () => {
        try {
            const response = await fetch("/api/usuarios/empresa");
            const data = await response.json();

            const usuarios = data[0][0].map(({
                    IdUsuario,
                    IdEmpleado,
                    IdSucursal,
                    Usuario,
                    Estado,
                    Roles,
                    Nombres,
                    Apellidos,
                    Sucursal,
                    RazonSocial
                }) => ({
                    IdUsuario,
                    IdEmpleado,
                    IdSucursal,
                    Usuario,
                    Estado,
                    Roles: [...new Set(JSON.parse(Roles))],
                    Empleado: `${Nombres} ${Apellidos}`,
                    Sucursal: Sucursal
                }));
            setUsuarios(usuarios);
        } catch (error) {
            Notify("Error al cargar usuarios", "error");
        }
    };

    useEffect(() => {
        fetchUsuarios();
    }, [usuario]);

    const cambiarEstadoUsuario = async (IdUsuario, estado, msg) => {
        if (!IdUsuario) {
            return Notify(`Error, id es '${IdUsuario}'`, "error");
        }

        try {
            const response = await fetch(`/api/usuarios/empresa/${IdUsuario}`, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Estado: estado })
            });
            const data = await response.json();
            
            if (data.error) {
                return Notify(data.error, "error");
            }
            
            Notify(msg);
            fetchUsuarios();
        } catch (error) {
            Notify("Error al actualizar usuario", "error");
        }
    };

    const onConfigureCajas = (usuario) => {
        setCajas(true);
        setUsuario(usuario);
    };

    const onEditUsuario = (usuario) => {
        setCajas(false);
        setUsuario(usuario);
    };

    const columns = [
        simpleReactTableColumn("Usuario"),
        simpleReactTableColumn("Empleado"),
        simpleReactTableColumn("Sucursal"),
        simpleReactTableColumn("Estado"),
        {
            Header: "Opciones",
            filterable: false,
            Cell: (f) => {
                const usuario = f.original;
                return (
                    <div align="center">
                        <BotonUsuarioCajas className="mr-3" onClick={() => onConfigureCajas(usuario)} />
                        <BotonEditar className="mr-3" onClick={() => onEditUsuario(usuario)} />
                        {usuario.Estado === "inactivo" ? (
                            <BotonCheck
                                onClick={() => cambiarEstadoUsuario(usuario.IdUsuario, 'activo', "El usuario se activó correctamente.")}
                            />
                        ) : (
                            <BotonDelete
                                onClick={() => cambiarEstadoUsuario(usuario.IdUsuario, 'inactivo', "Usuario inhabilitado exitosamente.")}
                            />
                        )}
                    </div>
                );
            }
        },
    ];

    return (
        <section className='ventas-fpay-section'>
            <div className="container py-4">
                <div className="d-flex justify-content-end mb-2">
                    <BotonLetras onClick={() => setUsuario({ Roles: [] })}>
                        Crear
                    </BotonLetras>
                </div>

                {usuarios && (
                    <ReactTable
                        data={usuarios}
                        columns={columns}
                        filterable
                    />
                )}
            </div>

            <Modal
                isOpen={usuario !== null}
                onClose={() => setUsuario(null)}
                title={cajas ? "Cajas habilitadas" : "Nuevo Usuario"}
            >
                {cajas ? (
                    <UsuarioCajasEmpresa
                        closeModal={() => setUsuario(null)}
                        Usuario={usuario}
                    />
                ) : (
                    <UsuarioFormEmpresa
                        closeModal={() => setUsuario(null)}
                        Usuario={usuario}
                    />
                )}
            </Modal>
        </section>
    );
};

export default UsuariosEmpresa;
